import { render, staticRenderFns } from "./ModalityOwnClientForm.vue?vue&type=template&id=7a600fb1"
import script from "./ModalityOwnClientForm.vue?vue&type=script&lang=js"
export * from "./ModalityOwnClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports